var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nodata"},[_c('img',{attrs:{"src":_vm.langSet == 'cn' ? require('../assets/nodata.png') : require('../assets/nodata01.png'),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }